export default "__VITE_ASSET__DMF11Htb__"